<template>
  <div class="academy-container">
    <header class="academy-hd">
      <div
        class="academy-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="academy-hd-subTitle">Delauney Academy</h4>
        <h2 class="academy-hd-title">Helping, Learning, and Certification</h2>
        <h4 class="academy-hd-subTitle">
          Explore knowledge, practical learning, and innovation with trusted
          partners.
        </h4>
        <h4 class="academy-hd-subTitle">Technical Support: 4000-025-828</h4>
      </div>
    </header>
    <article class="academy-bd">
      <AnchorTabs ref="academyAnchorTabsRef" :tabList="tabLists" />
      <div id="AIRoad">
        <BaseAcademy
          type="AIRoad"
          :videoList="aiRoadVideoList"
          :moreVideoUrl="moreVideoUrl.aiRoad"
        />
      </div>
      <div id="EICAD">
        <BaseAcademy
          type="EICAD"
          :videoList="eiCadVideoList"
          :moreVideoUrl="moreVideoUrl.eiCad"
        />
      </div>
      <div id="VRRoad">
        <BaseAcademy
          type="VRRoad"
          :videoList="vrRoadVideoList"
          :moreVideoUrl="moreVideoUrl.vrRoad"
        />
      </div>
      <div id="Report3D">
        <BaseAcademy
          type="Report3D"
          :videoList="report3DVideoList"
          :moreVideoUrl="moreVideoUrl.report3D"
        />
      </div>
      <div id="EducCenter">
        <EduLearnCenter type="EducCenter" />
      </div>
    </article>
  </div>
</template>
<script>
import AnchorTabs from "@/components/AnchorTabs.vue";
import BaseAcademy from "./BaseAcademy.vue";
import EduLearnCenter from "./EduLearnCenter.vue";
import {
  aiRoadVideoList,
  eiCadVideoList,
  vrRoadVideoList,
  report3DVideoList,
} from "./data";

import { collegevideoListApi } from "@/api/website";
export default {
  name: "Academy",
  components: { AnchorTabs, BaseAcademy, EduLearnCenter },
  data() {
    return {
      tabLists: [
        {
          name: "AIRoad",
          value: "AIRoad",
        },
        {
          name: "EICAD",
          value: "EICAD",
        },
        {
          name: "VRRoad",
          value: "VRRoad",
        },
        {
          name: "Report3D",
          value: "Report3D",
        },
        {
          name: "Education and Learning Center",
          value: "EducCenter",
        },
      ],
      // aiRoadVideoList: [...aiRoadVideoList],
      // eiCadVideoList: [...eiCadVideoList],
      // vrRoadVideoList: [...vrRoadVideoList],
      // report3DVideoList: [...report3DVideoList],
      aiRoadVideoList: [],
      eiCadVideoList: [],
      vrRoadVideoList: [],
      report3DVideoList: [],
      moreVideoUrl: {
        aiRoad: "",
        eiCad: "",
        vrRoad: "",
        report3D: "",
      },
    };
  },
  computed: {},
  created() {
    this.getVideoAll();
  },
  mounted() {
    this.type = this.$route.query.type;
    if (this.type) {
      // 需等待数据调用完成，页面渲染完成
      setTimeout(() => {
        this.$refs.academyAnchorTabsRef.handleTabClick(this.type);
      }, 500);
    }
  },
  methods: {
    getVideoAll() {
      collegevideoListApi().then((res) => {
        if (res.code == 200 && res.success) {
          console.log("collegevideoListApi", res);
          let airoadTemp = res.data.find(
            (item) => item.categoryName === "AIRoad",
          );
          let eicadTemp = res.data.find(
            (item) =>
              item.categoryName === "EACID" || item.categoryName === "EICAD",
          );
          let vrroadTemp = res.data.find(
            (item) => item.categoryName === "VRRoad",
          );
          let report3dTemp = res.data.find(
            (item) =>
              item.categoryName === "Repotr3D" ||
              item.categoryName === "Report3D",
          );

          // 更多视频的跳转地址
          this.moreVideoUrl = {
            aiRoad: airoadTemp.url,
            eiCad: eicadTemp.url,
            vrRoad: vrroadTemp.url,
            report3D: report3dTemp.url,
          };
          // 查找出已启用的数据
          let temp1 = airoadTemp.collegeVideoList.filter(
            (item) => item.startupStatus === "2",
          );
          this.aiRoadVideoList = temp1.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });

          let temp2 = eicadTemp.collegeVideoList.filter(
            (item) => item.startupStatus === "2",
          );
          this.eiCadVideoList = temp2.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });

          let temp3 = vrroadTemp.collegeVideoList.filter(
            (item) => item.startupStatus === "2",
          );
          this.vrRoadVideoList = temp3.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });

          let temp4 = report3dTemp.collegeVideoList.filter(
            (item) => item.startupStatus === "2",
          );
          this.report3DVideoList = temp4.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.academy-container {
  width: 100%;
  .academy-hd {
    width: 100%;
    height: 320px;
    background: url("~@/assets/images/academy/academy-hd_bg.png") no-repeat
      center;
    background-size: cover;
    .academy-hd-wrapper {
      width: 1049px;
      padding-top: 70px;
      margin: 0 auto;
    }
    .academy-hd-title {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 28px;
      color: #ffffff;
      line-height: 28px;
      font-style: normal;
    }
    .academy-hd-subTitle {
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      line-height: 27px;
      font-style: normal;
    }
  }
}
</style>
